import React from "react";
import Context from "../../../Context";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import Blocker from "../../Misc/Blocker";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import Select from "react-select";
import DeliveryHat from "./DeliveryHat";
import ProductPicker from "../../Misc/ProductPicker";

const deliveryTpes = {
  installation: "act.installation",
  cancellation: "act.cancellation",
  waybill: "m11.waybill",
  troubleshooting: "act.troubleshooting",
};

export default class Delivery extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      item: {},
      lines: [],
      products: [],
      measure: [],
      currency: [],
    };
  }

  componentDidMount() {
    this.loadReferences().then(() => this.load());
    this.renderButtons();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.deliveryId !== this.props.deliveryId ||
      prevProps.classcode !== this.props.classcode
    ) {
      this.load();
    }
    this.renderButtons();
  }

  onChange = (id, value) => {
    this.setState((state) => {
      let { item } = state;
      item[id] = value;
      return { item };
    });
  };

  onLineChange = (idx, key, value) => {
    let { lines } = this.state;
    lines[idx][key] = value;
    this.setState({ lines });
  };

  loadReferences = async () => {
    this.setState({ pending: true });
    let products = await this.context.api.qr("/product/list");
    let measure = await this.context.api.qr("/measure/list");
    let currency = await this.context.api.qr("/currency/list");
    this.setState({ pending: false, products, measure, currency });
  };

  rowAdd = (idx) => {
    let { lines } = this.state;
    let index = idx || lines.length;
    lines.splice(index, 0, {});
    this.setState({ lines });
  };

  rowRemove = (idx) => {
    let { lines } = this.state;
    lines.splice(idx, 1);
    this.setState({ lines });
  };

  load = async () => {
    const { deliveryId, classcode } = this.props;

    if (!classcode) {
      this.setState({ notFound: true });
      return;
    } else {
      let access = this.context.user.classAccess[classcode] || {};
      if (!access.c && !access.u) {
        this.setState({ notFound: true });
        return;
      }
    }

    this.setState({ pending: true, notFound: false });
    if (deliveryId && deliveryId !== "add") {
      let item = await this.context.api.q("/delivery/get", { id: deliveryId });
      if (!item) {
        this.setState({ notFound: true });
      } else {
        if (item.classcode !== classcode) {
          this.setState({ notFound: true });
        } else {
          let lines = await this.context.api.qa("/delivery/item/list", {
            filter: { documentid: deliveryId },
            orderby: ["itemid ASC"],
          });

          this.setState({ item, lines: lines || [] });
        }
      }
    } else {
      let lines = [];
      let searchParams = new URLSearchParams(
        this.props.location.search.substr(1)
      );
      let append = searchParams.get("append");
      if (append) {
        let appendItems = append.split(",");
        appendItems.forEach((id) => {
          lines.push({ productid: id });
        });
      }

      this.setState({
        item: {
          classcode: this.props.classcode,
        },
        lines,
      });
    }
    this.setState({ pending: false });
    this.context.force();
  };

  save = async () => {
    let deliveryId = null;
    if (this.props.deliveryId && this.props.deliveryId !== "add") {
      deliveryId = this.props.deliveryId;
    }

    let itemsPrepareError = false;
    let items = [];
    let { lines } = this.state;
    lines.forEach((line) => {
      let model = line.model || {};
      let lineName = model.name || "";

      if (line.productid) {
        if (line.volume) {
          items.push({
            productid: line.productid,
            volume: line.volume,
          });
        } else {
          this.context.toast("Не указано количество " + lineName, "error");
          itemsPrepareError = true;
          return;
        }
      }
    });

    if (itemsPrepareError) return;

    const { item } = this.state;
    this.setState({ pending: true });
    let saveData = {
      id: deliveryId,
      description: item.description,
      type: this.context.getType(deliveryTpes[item.classcode]),
      receiver: item.receiver || null,
      parent: item.parent || null,
    };
    let result = await this.context.api.q("/delivery/set", saveData);

    if (result !== false) {
      let itemsResult = await this.context.api.q("/delivery/item", {
        items,
        document: result.id,
      });
      if (itemsResult !== false) {
        this.context.toast("Изменения сохранены", "success");
      } else {
        this.context.toast("Не удалось сохранить изменения", "error");
      }

      this.setState({ pending: false });
      if (this.props.deliveryId === "add") {
        this.context.redirect(`/delivery/${result.classcode}/${result.id}`);
      } else {
        if (itemsResult !== false) {
          this.load();
        }
      }
    } else {
      this.setState({ pending: false });
      this.context.toast("Не удалось сохранить изменения", "error");
    }
  };

  new = () => {
    const { item } = this.state;
    this.setState({ lines: [] });
    this.context.redirect(`/delivery/${item.classcode}/add`);
  };

  open = () => {
    const { deliveryId } = this.props;
    if (deliveryId && deliveryId !== "add") {
      this.context.redirect(`/workdoc/any/any/${deliveryId}`);
    } else {
      this.context.redirect("/workdoc/");
    }
  };

  renderButtons = () => {
    this.context.actionsSet(
      <>
        <button
          title="Новый"
          onClick={this.new}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-file-o"></i>
        </button>
        <button
          title="Сохранить"
          onClick={this.save}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-save"></i>
        </button>
        <button
          title="Открыть"
          onClick={this.open}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-folder-open-o"></i>
        </button>
      </>
    );
  };

  render() {
    const { item, notFound, pending, lines } = this.state;
    const { deliveryId } = this.props;
    const typeDefaultLabels = {
      installation: "Новый акт установки",
      cancellation: "Новый акт списания",
      waybill: "Новый акт передачи",
      troubleshooting: "Новый акт дефектации",
    };
    let title =
      deliveryId === "add" ? typeDefaultLabels[item.classcode] : item.label;

    if (notFound) {
      title = "Документ не найден";
      return (
        <div className="container">
          <CrumbsProvider title={title} />
          <DefaultNotFound />
        </div>
      );
    }

    return (
      <>
        <CrumbsProvider
          title={title}
          link={`/delivery/${item.classcode}/${item.id}/`}
        />
        <div className="container h-100">
          <div className="row  h-100">
            <div className="col">
              <div className="card card-custom card-stretch">
                <Blocker on={pending}>
                  <div className="card-body px-5 py-5">
                    <div className="dochat">
                      <div className="flex-grow-1">
                        <DeliveryHat item={item} onChange={this.onChange} />
                      </div>
                      {item.id && (
                        <div className="d-flex align-items-center ml-3 pt-2">
                          <EssenceStateLabel
                            onAfterStateChanged={(c) => {
                              if (c === "enabled") {
                                this.open();
                              }
                            }}
                            stateCode={item.statetypecode}
                            stateLabel={item.statelabel}
                            essence="delivery"
                            id={item.id}
                          />
                          <EssenceActionsDropdown
                            essence={"delivery"}
                            key={item.id}
                            id={item.id}
                            label={item.label}
                            onFinish={this.load}
                          />
                        </div>
                      )}
                    </div>
                    <table className="table">
                      <thead>
                        <tr>
                          <th width="40%">
                            <i
                              title="Добавить строку"
                              onClick={() => this.rowAdd()}
                              className="fa fa-plus cursor-pointer text-hover-primary mr-2"
                            ></i>
                            Наименование
                          </th>
                          <th width="15%">Кол-во</th>
                          <th width="15%">Eд. изм.</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lines.map((item, idx) => {
                          let line = item || {};
                          let currency = line.currency || {};
                          return (
                            <tr key={idx}>
                              <td>
                                <ProductPicker
                                  defaultItem={line.product}
                                  defaultValue={line.productid}
                                  onChange={(value) =>
                                    this.onLineChange(idx, "productid", value)
                                  }
                                />
                                {/*
                                <Select
                                  value={this.context.api.getReferenceValue(
                                    line.productid,
                                    this.state.products
                                  )}
                                  onChange={(result) =>
                                    this.onLineChange(
                                      idx,
                                      "productid",
                                      result.value
                                    )
                                  }
                                  className="from-control react-select"
                                  classNamePrefix="react-select-inner"
                                  options={this.state.products}
                                  placeholder="..."
                                  noOptionsMessage={({ inputValue }) =>
                                    `Ничего не найдено по запросу ${inputValue}`
                                  }
                                  filterOption={this.context.api.filterOption}
                                />
                                */}
                              </td>
                              <td>
                                <input
                                  className="form-control"
                                  value={line.volume || ""}
                                  size={3}
                                  type="number"
                                  onChange={(e) =>
                                    this.onLineChange(
                                      idx,
                                      "volume",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>

                              <td valign="center">
                                <div className="d-flex align-items-center ">
                                  <div className="flex-grow-1">
                                    <Select
                                      value={this.context.api.getReferenceValue(
                                        line.measureid,
                                        this.state.measure
                                      )}
                                      onChange={(result) =>
                                        this.onLineChange(
                                          idx,
                                          "measureid",
                                          result.value
                                        )
                                      }
                                      className="from-control react-select"
                                      classNamePrefix="react-select-inner"
                                      options={this.state.measure}
                                      placeholder="..."
                                      noOptionsMessage={({ inputValue }) =>
                                        `Ничего не найдено по запросу ${inputValue}`
                                      }
                                    />
                                  </div>
                                  <div className="ml-3 text-nowrap">
                                    <i
                                      title="Удалить строку"
                                      onClick={() => this.rowRemove(idx)}
                                      className="fa fa-times cursor-pointer text-hover-danger "
                                    ></i>
                                    <i
                                      title="Добавить строку ниже"
                                      onClick={() => this.rowAdd(idx + 1)}
                                      className="fa fa-plus cursor-pointer text-hover-primary ml-2"
                                    ></i>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </Blocker>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
